<template src="./html/employee-turn.html"></template>

<style lang="scss" src="./styles/main.scss"></style>

<script>
import formMixin from '../mixin';

export default {
  name: 'EmployeeTurn',
  mixins: [ formMixin ],
  data: () => ({
    number_weeks_in_year: '52',
  }),
  computed: {
    number_knowledge_loss() {
      return Math.round(this.data.cost_avg_salary.replace(this.re, '') * this.data.number_avg_tenure.replace(this.re, '') * .05);
    },
    loss_of_knowledge_subtotal() {
      return Math.round((this.data.cost_avg_salary.replace(this.re, '') / this.number_weeks_in_year.replace(this.re, '') * (this.data.percent_productivity_reduction.replace(this.re, '') / 100) * this.data.number_fill_position_weeks) + this.number_knowledge_loss);
    },
    replacement_subtotal() {
      return Math.round((this.data.cost_hr_salary.replace(this.re, '') / 2000 * this.data.number_replacement_fill_position_hours.replace(this.re, '')) + +this.data.cost_ad_and_identity_check.replace(this.re, ''));
    },
    training_subtotal() {
      return Math.round(this.data.cost_new_hire_trainer.replace(this.re, '') / 2000 * this.data.number_total_training_hours.replace(this.re, ''));
    },
    ramp_up_subtotal() {
      const subtotal = Math.round(this.data.cost_avg_salary.replace(this.re, '') / this.number_weeks_in_year * (100 - this.data.percent_new_hire_productivity.replace(this.re, '')) / 100 * this.data.number_weeks_to_full_productivity.replace(this.re, ''));
      return subtotal < 0 ? 0 : subtotal;
    },
    cost_per_employee() {
      return Math.round(this.loss_of_knowledge_subtotal + this.replacement_subtotal + this.training_subtotal + this.ramp_up_subtotal);
    },
    total_cost() {
      const subtotal = this.cost_per_employee * this.data.number_employees_lost.replace(this.re, '');
      return subtotal < 0 ? 0 : subtotal;
    }
  },
  methods: {
    initialState() {
      return {
        cost_avg_salary: '60000',
        number_employees_lost: '65',
        number_fill_position_weeks: '8',
        number_avg_tenure: '1',
        percent_productivity_reduction: '30',
        cost_hr_salary: '80000',
        number_replacement_fill_position_hours: '35',
        cost_ad_and_identity_check: '900',
        cost_new_hire_trainer: '100000',
        number_total_training_hours: '45',
        percent_new_hire_productivity: '60',
        number_weeks_to_full_productivity: '10'
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmployeeTurn.vue